import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core'
import { SharedService } from '@flowaccount/landing'
import { TranslateService } from '@ngx-translate/core'
export interface IGoodPointList {
  title: string
  description: string
  imgWebp: string
  img: string
  linkVideo?: string
  readMore?: string
  alt: string
}
@Component({
  selector: 'flowaccount-business-good-point',
  templateUrl: './business-good-point.component.html',
  styleUrls: ['./business-good-point.component.scss'],
})
export class BusinessGoodPointComponent implements OnInit {
  constructor(
    public translate: TranslateService,
    public sharedService: SharedService,
    public cdref: ChangeDetectorRef,
  ) {}
  public currentSlide = 1
  public intervalSlide
  @Input() goodPointList: IGoodPointList[]
  @Input() mockContent: string
  ngOnInit(): void {
    this.setTimeOutNexSlide()
  }

  ngDestroy() {
    clearInterval(this.intervalSlide)
  }

  actionClickSlide(actionName: string) {
    const slide = this.currentSlide
    const speakerListLength = this.goodPointList.length
    if (actionName === 'prev') {
      if (slide === 1) {
        this.currentSlide = speakerListLength
      } else {
        this.currentSlide -= 1
      }
    } else if (actionName === 'next') {
      if (slide === speakerListLength) {
        this.currentSlide = 1
      } else {
        this.currentSlide += 1
      }
    }
    clearInterval(this.intervalSlide)
    this.setTimeOutNexSlide()
  }

  displaySlideClass(index) {
    if (index === this.currentSlide) return 'slide--' + index
  }

  linkVideo(youtubeURL: string) {
    return this.sharedService.openVideoTutorialModal(youtubeURL)
  }

  goToSlide(slideNo: number) {
    clearInterval(this.intervalSlide)
    this.setTimeOutNexSlide()
    return (this.currentSlide = slideNo)
  }

  setTimeOutNexSlide() {
    // 60 second for seeing each slide detail
    const time = 60000
    this.intervalSlide = setInterval(() => {
      if (this.currentSlide === this.goodPointList.length) {
        this.currentSlide = 1
      } else {
        this.currentSlide += 1
      }
      // detect change for slide value change
      this.cdref.detectChanges()
    }, time)
  }
}
